import { useEffect, useLayoutEffect, useState } from "react";

import useModal from "@components/@Portal/ModalContainer/hook";
import { useModalStoreClear } from "@components/@Portal/ModalContainer/store";
import PopupModal from "@components/Modals/Popup";
import MobilePopupSwiper from "@components/Modals/Popup/MobileSwiper";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import { useGetPopups } from "@api/popup";

import { cookieStorage } from "@utils/cookieStorage";
import { debounce } from "@utils/debounce";

import ContactSection from "./contactSection";
import IntroSection from "./introSection";
import TechIntroSection_1 from "./techIntroSection_1";
import TechIntroSection_2 from "./techIntroSection_2";
import TechIntroSection_3 from "./techIntroSection_3";
import "./style.scss";
gsap.registerPlugin(ScrollTrigger);

export default function Home() {
	const { data: popups } = useGetPopups();
	const { openModal } = useModal();
	const clearModals = useModalStoreClear();
	const [isLoaded, setIsLoaded] = useState(false);

	useEffect(() => {
		const list = popups?.data;
		const isMobile = window.matchMedia("(max-width: 768px)").matches;
		if (!list || list.length === 0) return;

		if (isMobile) {
			// 모바일: 오늘 보지 않기 쿠키가 전체 차단이면 스킵
			const hideAll = cookieStorage.get("popup-hide-all");
			const mobileList = list.filter((p) => p.imageMobileUrl);
			if (!hideAll && mobileList.length > 0) {
				openModal(MobilePopupSwiper, {
					key: `popup-mobile-swiper`,
					popups: mobileList,
					aspectRatio: "9 / 16",
				});
			}
			return;
		}

		// 데스크탑: 기존 로직, 개별 팝업 렌더
		for (const p of list) {
			const hideKey = `popup-hide-${p.id}`;
			const cookie = cookieStorage.get(hideKey);
			if (cookie) continue;
			const wantMobile = p.imageMobileUrl;
			const wantPc = p.imageUrl;
			if ((isMobile && !wantMobile) || (!isMobile && !wantPc)) continue;
			openModal(PopupModal, { key: `popup-${p.id}`, popup: p });
		}
	}, [popups]);

	useLayoutEffect(() => {
		const refreshAll = debounce(() => {
			ScrollTrigger.refresh();
		}, 200);
		const waitForImages = async () => {
			const images = Array.from(document.images);
			await Promise.all(
				images.map(
					(img) =>
						new Promise<void>((resolve) => {
							if (img.complete) return resolve();
							img.addEventListener("load", () => resolve(), { once: true });
							img.addEventListener("error", () => resolve(), { once: true });
						}),
				),
			);

			if (document.fonts && document.fonts.ready) {
				try {
					await document.fonts.ready;
				} catch (e) {
					console.warn(e);
				}
			}

			requestAnimationFrame(() => setIsLoaded(true));
		};

		waitForImages();

		window.addEventListener("resize", refreshAll);
		return () => {
			window.removeEventListener("resize", refreshAll);
		};
	}, []);

	// 페이지 이탈(언마운트) 시 열린 모달 모두 정리
	useEffect(() => {
		return () => {
			clearModals();
		};
	}, [clearModals]);
	return (
		<main className="main-container">
			<IntroSection />
			{isLoaded && <TechIntroSection_1 />}
			{isLoaded && <TechIntroSection_2 />}
			{isLoaded && <TechIntroSection_3 />}
			<ContactSection />
		</main>
	);
}
